import { KYDScope } from "@common/interfaces/ICognito";

export interface PermissionNode {
  name: string;
  children?: PermissionNode[];
  scopes: {
    read?: KYDScope;
    write?: KYDScope;
  };
}

export const organizationPermissionStructure: PermissionNode[] = [
  {
    name: "organizations",
    scopes: { read: "organizations/read", write: "organizations/write" },
    children: [
      {
        name: "events",
        scopes: {
          read: "organizations/events:read",
          write: "organizations/events:write",
        },
      },
      {
        name: "overview",
        scopes: {
          read: "organizations/overview:read",
          write: "organizations/overview:write",
        },
      },
      {
        name: "payouts",
        scopes: {
          read: "organizations/payouts:read",
          write: "organizations/payouts:write",
        },
      },
      {
        name: "users",
        scopes: {
          read: "organizations/users:read",
          write: "organizations/users:write",
        },
      },
      {
        name: "bundles",
        scopes: {
          read: "organizations/bundles:read",
          write: "organizations/bundles:write",
        },
      },
      {
        name: "bio",
        scopes: {
          read: "organizations/bio:read",
          write: "organizations/bio:write",
        },
      },
    ],
  },
];

export const eventPermissionStructure: PermissionNode[] = [
  {
    name: "events",
    scopes: { read: "events/read", write: "events/write" },
    children: [
      {
        name: "metadata",
        scopes: {
          read: "events/metadata:read",
          write: "events/metadata:write",
        },
      },
      {
        name: "ticket_types",
        scopes: {
          read: "events/ticket_types:read",
          write: "events/ticket_types:write",
        },
      },
      {
        name: "promo_codes",
        scopes: {
          read: "events/promo_codes:read",
          write: "events/promo_codes:write",
        },
      },
      {
        name: "access_codes",
        scopes: {
          read: "events/access_codes:read",
          write: "events/access_codes:write",
        },
      },
      {
        name: "marketing",
        scopes: {
          read: "events/marketing:read",
          write: "events/marketing:write",
        },
      },
      // TODO: uncomment to launch campaigns
      // {
      //   name: "campaigns",
      //   scopes: {
      //     read: "events/campaigns:read",
      //     write: "events/campaigns:write",
      //   },
      // },
      {
        name: "guestlist",
        scopes: {
          read: "events/guestlist:read",
          write: "events/guestlist:write",
        },
      },
      {
        name: "attendees",
        scopes: {
          read: "events/attendees:read",
          write: "events/attendees:write",
        },
      },
      {
        name: "waitlist",
        scopes: {
          read: "events/waitlist:read",
          write: "events/waitlist:write",
        },
      },
      {
        name: "affiliates",
        scopes: {
          read: "events/affiliates:read",
          write: "events/affiliates:write",
        },
      },
      {
        name: "analytics",
        scopes: {
          read: "events/analytics:read",
        },
      },
      {
        name: "reports",
        scopes: {
          read: "events/reports:read",
          write: "events/reports:write",
        },
      },
      {
        name: "boxoffice",
        scopes: {
          read: "events/boxoffice:read",
          write: "events/boxoffice:write",
        },
      },
    ],
  },
];

export const crmPermissionStructure: PermissionNode[] = [
  {
    name: "crm",
    scopes: { read: "crm/read", write: "crm/write" },
    children: [
      {
        name: "campaigns",
        scopes: {
          read: "crm/campaigns:read",
          write: "crm/campaigns:write",
        },
      },
      {
        name: "contacts",
        scopes: {
          read: "crm/contacts:read",
          write: "crm/contacts:write",
        },
      },
      {
        name: "segments",
        scopes: {
          read: "crm/segments:read",
          write: "crm/segments:write",
        },
      },
      {
        name: "imports",
        scopes: {
          read: "crm/imports:read",
          write: "crm/imports:write",
        },
      },
    ],
  },
];

/**
 * Event collaborator (organization) specific permissions.
 * Narrow, share-focused set: only allow reading event contacts.
 */
export const contactsPermissionStructure: PermissionNode[] = [
  {
    name: "contacts",
    scopes: { write: "external/contacts:write" },
  },
];
